"use client";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/atoms/tabs";
import { ICMSIncentivo, ICmsIncentivosData, IPAGEIncentivo } from "@/services/types";
import { useState, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import DetalhesIncentivoSection from "./DetalhesIncentivoSection";

interface IncentivosPageClientProps {
    incentivosData: ICmsIncentivosData | null;
    pageData: IPAGEIncentivo | null;
}
export default function IncentivosPageClient({ incentivosData, }: IncentivosPageClientProps) {
    const searchParams = useSearchParams();
    const tabFromUrl = searchParams.get('tab');

    const [activeTab, setActiveTab] = useState<string>(
        tabFromUrl || (incentivosData?.incentivos?.[0] ? incentivosData?.incentivos?.[0].slug : "")
    );

    useEffect(() => {
        if (tabFromUrl && incentivosData?.incentivos?.some(i => i.slug === tabFromUrl)) {
            setActiveTab(tabFromUrl);
        }
    }, [tabFromUrl, incentivosData]);

    console.log("[PAGE CLIENT] IncentivosPageClient props:", { incentivosData, activeTab, tabFromUrl });

    // Usar o contexto do banner para atualizar as informações
    const incentivos: ICMSIncentivo[] | undefined = incentivosData?.incentivos;

    const tabsTitles = incentivosData?.incentivos.map((incentivo: ICMSIncentivo) => ({ title: incentivo.title, value: incentivo.slug }));

    if (!incentivosData) {
        return (
            <div className="flex justify-center items-center min-h-[400px]">
                <div className="text-center">
                    <div className="w-16 h-16 border-4 rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600 text-lg">Carregando detalhes da incentivo...</p>
                </div>
            </div>
        );
    }

    return (
        <section className="relative w-full container mx-auto flex flex-col px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-6 sm:py-8 lg:py-12">
            {/* Content Grid */}
            <div className="flex flex-col lg:flex-row gap-12">

                {/* Left Side - tabs */}
                <div className="space-y-3 lg:w-4/12">
                    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
                        <TabsList className="flex flex-col h-auto bg-transparent">
                            {tabsTitles && tabsTitles.map((tabsTitle, index) => (
                                <TabsTrigger
                                    key={index}
                                    value={tabsTitle.value}
                                    className={`justify-start mb-2 cursor-pointer bg-white h-16 w-full rounded-sm shadow-[0px_8.542858123779297px_20.26080894470215px_0px_rgba(139,141,142,0.15)]
                                    ${activeTab === tabsTitle.value
                                            ? 'border-[#F7941D] text-[#F7941D] border'
                                            : 'border-0 text-[#2B2F31]'
                                        }`}>
                                    <div className={`${activeTab === tabsTitle.value
                                        ? 'text-[#F7941D] border'
                                        : 'text-[#2B2F31]'
                                        }text-2xl font-nunito text-start`}>
                                        {tabsTitle?.title || `questao ${index}`}
                                    </div>
                                </TabsTrigger>
                            ))}
                        </TabsList>
                    </Tabs>

                </div>

                {/* Right Side - TabContent */}
                <div className="flex items-start lg:w-8/12">
                    <div className="py-2 w-full">
                        <Tabs value={activeTab} onValueChange={setActiveTab}>
                            {incentivos && incentivos.map((incentivo: ICMSIncentivo, index) => (
                                <TabsContent key={`incentivos-${index}`} value={incentivo.slug} className="mt-0">
                                    <DetalhesIncentivoSection incentivo={incentivo} />
                                </TabsContent>
                            ))}
                        </Tabs>
                    </div>
                </div>
            </div>
        </section>);

};